<script setup>
import { PrimaryButton } from "@codinglabsau/ui";
import { onMounted, watch, ref } from "vue";
import { NodeViewWrapper, nodeViewProps, NodeViewContent } from "@tiptap/vue-3"
import { NewspaperIcon, PlusIcon } from "@heroicons/vue/24/solid";
import useSelectContentModal from "@/Composables/useSelectContentModal";
import EditableNodeWrapper from "./../../Components/EditableNodeWrapper.vue";
import ContentCardPreview from "@/Components/Inputs/BlockEditor/Extension/Components/Content/ContentCardPreview.vue";

const props = defineProps({
  ...nodeViewProps,
})

let selectedArticles = ref([]);

onMounted(() => {
  if (props.extension.options.data.hasOwnProperty(props.node.attrs.id)) {
    selectedArticles.value = [...props.extension.options.data[props.node.attrs.id].contents]
  }
})

const addArticle = (article) => {
  if (selectedArticles.value.find(obj => obj.id === article.id)) {
    alert(__('Article :article already added', { article: article.name }))
    return
  }
  selectedArticles.value.push(article);
}

const { open } = useSelectContentModal(addArticle)

const onRemoveArticle = (id) => {
  selectedArticles.value = selectedArticles.value.filter((article) => article.id !== id);
}

// update the articles when selectedArticles changes
watch(() => selectedArticles.value, () => {
  props.updateAttributes({
    articles: selectedArticles.value.map((article) => article.id),
  });
}, { deep: true })
</script>

<template>
  <node-view-wrapper>
    <EditableNodeWrapper v-bind="props">
      <template #content>
        <node-view-content class="prose first:prose-headings:mt-2" />
        <div
          v-if="selectedArticles.length > 0"
          class="grid md:grid-cols-2 gap-2 p-4 not-prose"
        >
          <div v-for="article in selectedArticles" class="relative min-w-0 max-w-full">
            <ContentCardPreview
              :content="article"
              @remove="onRemoveArticle"
            />
          </div>
          <div class="flex mx-auto my-3 items-center">
            <PrimaryButton
              @click.prevent="open"
              as="button"
            >
              <PlusIcon class="h-5 w-5" aria-hidden="true" />
            </PrimaryButton>
          </div>
        </div>
        <div v-else class="my-4 text-center space-y-1 not-prose">
          <NewspaperIcon class="mx-auto w-12 h-12 text-gray-300" />
          <h3 class="text-sm font-semibold text-gray-600">No Article</h3>
          <p class="text-gray-400 text-sm">{{ __('Select or search an Article') }}</p>
          <PrimaryButton
            @click.prevent="open"
            as="button"
          >
            <PlusIcon class="-ml-0.5 mr-1.5 h-5 w-5" aria-hidden="true" />
            {{ __('Select Article') }}
          </PrimaryButton>
        </div>
      </template>
    </EditableNodeWrapper>
  </node-view-wrapper>
</template>
